export default {
  FETCHED_SINGLE: 'FETCHED_MARKET_PRICES',
};
